import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} anonymous chat home`,
    languageButtonLabel: `Language`,
    languageModalTitle: `Pick your language`,
    languageModalCloseLabel: `Close language menu`,
  },
  languageOptions: {
    'en-US': {
      label: `Ínglish (Yunaítẹ́d Stets)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Ínglish (Kẹ́nya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Ínglish (Naijíria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Ínglish (Singapọ)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Pọtiugiz (Pọ́túgal)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Pọtiugiz (Brázil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Jámán Lángwej (Jámáni)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Jámán Lángwej (Ọ́stria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Jámán Lángwej (Swítsaland)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spánish Lángwej (Spen)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Frẹ́nch Lángwej (Frans)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Ítáli Lángwej (Ítáli)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Dọch Lángwej (Nẹ́dalands)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Pólánd Lángwej (Póland)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Suwídẹ́n Lángwej (Swídẹn)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dénísh Lángwej (Dẹ́nmak)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Fínísh Lángwej (Fínland)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Nọ́wẹ́jiá Lángwej (Nọ́we)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Aíslánd Lángwej (Aísland)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japan Lángwej (Japán)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koriá Lángwej (Saút Koria)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarín Chainíz Lángwej (Chaína)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kántọn Lángwej (Họng Kọng SAR)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Viẹ́tnám Lángwej (Viẹ́tnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Taí (Taíland)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indoníshia Lángwej (Indoníshia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahíli (Kẹ́nya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Híndi Lángwej (Índia)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bángla Lángwej (Bangladẹsh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marátí Lángwej (Índia)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Tẹlugu (Índia)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Pẹ́shiá Lángwej (Irán)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Úrdú (Pakístan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjábi (Pakístan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijíriá Píjin (Naijíria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Rọshiá Lángwej (Rọ́shia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arábík Lángwej (Saúdí Arébia)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arábík Lángwej (Yunaítẹ́d Áráb Ẹ́mírets)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arábík Lángwej (Kata)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Tọ́ki (Tọ́ki)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Pick your language`,
    closeLabel: `Close language menu`,
  },
  languageHint: (ctx) => `Jump around ${ctx.localesCount}+ locales, no need account.`,
  readPagePrompt: ({languageLabel}) => `Read this page inside ${languageLabel}.`,
};
